/**
 * This store manage the progress of a submission.
 * It depends on the submission data and the rules specified for the steps
 */
import Vue from 'vue';
import rulesLibrary from '@/components/Submission/rules';
import store from '../';

export default {
  namespaced: true,
  state: {},
  getters: {
    hasError: state => (id, index) => {
      if (!state[id]) return true;

      const stepResults = state[id][index];
      if (!stepResults) return false;

      const completeness = stepResults.some(result => !!result.error);
      return completeness;
    },
    submittable: (state, getters) => (id) => {
      if (!state[id]) return false;
      else {
        return !state[id].some((stepResults, index) => getters.hasError(id, index));
      }
    },

  },
  mutations: {
    update(state, { id, results }) {
      Vue.set(state, id, results);
    },
  },
  actions: {
    update({ state, commit, getters }, id) {
      const submission = store.state.submission[id];
      const results = rulesLibrary.managers.map((fn, index) =>
        fn(rulesLibrary.rules[index], submission)
          .filter(result => result != null)
      );
      commit('update', {
        id,
        results,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/submissionProgress.js